import React, { useState } from 'react';
import { DialogNames } from '../../Types';
import { useDialogsContext } from '../../contexts/Dialog';
import { Button } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomDialog from '../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import RadioGroup from '../BuildingBlocks/Form/RadioGroup';
import Comment from '../BuildingBlocks/Text/Comment';
import { useForm, useWatch } from 'react-hook-form';
import messages from '../../messages';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { proposeAlternativePlan } from '../API';

const useStyles = makeStyles((theme: any) => ({
  button: {
    borderRadius: theme.spacing(0.5),
    fontSize: 'large',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    width: 150,
  },
  radioGroup: {
    marginBottom: theme.spacing(3.5),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(5),
  },
}));

export default function ProposeAlternativeReasonDialog({ plan }) {
  const dialog: any = useDialogsContext();
  const snackbar = useSnackbarContext();
  const { setValue, control } = useForm();
  const proposeAlternativeReason = useWatch({
    control,
    name: 'proposeAlternativeReason',
  });
  const [freeText, setFreeText] = useState('');
  const classes = useStyles();

  const purposeAlternativeReasonOptions = [
    {
      id: 'My sales are on schedule',
      text: <span>My sales are on schedule</span>,
    },
    {
      id: 'I do not forecast having excess inventory',
      text: <span>I do not forecast having excess inventory</span>,
    },
    {
      id: "I've already placed order(s) for future Line(s)",
      text: <span>I've already placed order(s) for future Line(s)</span>,
    },
    {
      id: 'Other',
      text: <span>Other</span>,
    },
  ];

  const onCloseDialog = () => {
    setValue('proposeAlternativeReason', undefined);
    setFreeText(undefined);
    dialog.close(DialogNames.ProposeAlternativePlan);
  };

  const onChangeTextArea = (e) => {
    e.preventDefault();
    setFreeText(e.target.value);
  };

  const disabledContinueButton = () => {
    return !proposeAlternativeReason || !freeText;
  };

  const onClickSubmit = async () => {
    try {
      await proposeAlternativePlan(plan.id, proposeAlternativeReason, freeText);
      onCloseDialog();
      snackbar.show(messages.plans.proposeAlternativeChange);
    } catch (e) {
      snackbar.show(messages.plans.errors.proposeAlternativeChange, 'error');
    }
  };

  return (
    <CustomDialog
      open={dialog[DialogNames.ProposeAlternativePlan]}
      header={
        'Please inform our team how we could better adjust your Growth Plan'
      }
      onClose={onCloseDialog}
    >
      <div className={classes.radioGroup}>
        <RadioGroup
          groupId="proposeAlternativeReason"
          options={purposeAlternativeReasonOptions}
          setValue={setValue}
          useWatch={useWatch}
          control={control}
        />
      </div>
      <Comment
        commentId={'alternativeFreeText'}
        placeholder={
          'Please inform our team how we could better adjust your Growth Plan (required)'
        }
        maxLength={150}
        defaultValue={freeText}
        onChangeFunc={onChangeTextArea}
      />
      <div className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={disabledContinueButton()}
          onClick={async () => await onClickSubmit()}
        >
          Submit
        </Button>
      </div>
    </CustomDialog>
  );
}
